import { useContext, useEffect } from "react";
import { THEME_SETTINGS } from "@theme-settings";
import { LiveStatus } from "@gp/models";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export const useFavoritesCounter = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => {}
	: (livestatus: LiveStatus) => {
			const favoriteStore = useContext(FavoritesStoreContext);
			const rootStore = useRootAppStore();

			async function onInit() {
				if (rootStore.userAuthStore.isLoggedIn) {
					if (livestatus == LiveStatus.PREMATCH) {
						await favoriteStore.onInitializePrematchFavorites();
					} else {
						await favoriteStore.onInitializeLiveFavorites();
					}
				}
			}

			useEffect(() => {
				onInit();
				return () => {
					if (livestatus == LiveStatus.PREMATCH) {
						favoriteStore.disposePrematchReaction();
					} else {
						favoriteStore.disposeLiveReaction();
					}
				};
			}, [rootStore.userAuthStore.isLoggedIn]);
		};
